module.exports = __webpack_public_path__ + "img/backs.48d72b51.png";